import ClientList from './components/ClientList';

const ForOnboarding = () => {
  return (
    <ClientList
      title="For Onboarding Clients"
      initialFilters={[
        {
          attribute: 'status',
          operator: 'EQ',
          value: 'ACTIVE',
        },
        {
          attribute: 'isOnboarding',
          operator: 'EQ',
          value: true,
        },
      ]}
      editableColumns={[
        'projectManager',
        'brandStrategist',
        'accountSpecialist',
      ]}
      defaultColumns={[
        'client',
        'status',
        'service',
        'subscription',
        'projectManager',
        'brandStrategist',
        'accountSpecialist',
        'contractSigned',
      ]}
      excludeColumns={[
        'agencyClientId',
        'terminatedAt',
        'invoiceSummary',
        'termination.createdAt',
        'termination.requestor.firstName',
        'termination.evaluator.firstName',
        'terminationReason',
        'totalPaidInvoiceAmount',
        'totalUnPaidInvoiceAmount',
      ]}
      initialParams={{
        page: 1,
        pageSize: 10,
        sorts: 'client:asc',
        search: '',
        filters: '[]',
        include: [
          'subscription',
          'defaultContact',
          'projectManager[user[avatar]]',
          'brandStrategist[user[avatar]]',
          'accountSpecialist[user[avatar]]',
        ],
        attributes: [
          'phone',
          'client',
          'status',
          'service',
          'address',
          'website',
          'accountStatus',
          'amazonPageUrl',
          'agencyClientId',
          'draftMarketplace',
          'contractSigned',
          'salesClientId',
          'subscriptionPaymentOption',
        ],
      }}
    />
  );
};

export default ForOnboarding;
